import RpcService  from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';

import type VehicleType from '@/domains/VehicleTypes/VehicleType';

/**
 * DAO для работы с типами транспортов
 */
class VehicleTypesDAO {

	static async getList(
    filters?: {
      id?: number
    }
  ): Promise<RpcResponse> {
		return await RpcService.makeRequest('vehicleTypes.getList', filters);
	}

	static async add(vehicleType: VehicleType): Promise<RpcResponse> {
		return await RpcService.makeRequest('vehicleTypes.add', { vehicleType });
	}

	static async update(vehicleType: VehicleType): Promise<RpcResponse> {
		return await RpcService.makeRequest('vehicleTypes.update', { vehicleType });
	}

	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('vehicleTypes.delete', { id });
	}
}

export default VehicleTypesDAO;
